
import { useState } from "react";

interface UseInputAnimationProps {
  disabled?: boolean;
}

export function useInputAnimation({ disabled = false }: UseInputAnimationProps = {}) {
  const [isFocused, setIsFocused] = useState(false);
  const [hasInteracted, setHasInteracted] = useState(false);
  
  const handleFocus = () => {
    if (disabled) return;
    setIsFocused(true);
    setHasInteracted(true);
  };
  
  const handleBlurWithAnimation = (callback: (e: React.FocusEvent<HTMLInputElement>) => void) => {
    return (e: React.FocusEvent<HTMLInputElement>) => {
      setIsFocused(false);
      callback(e);
    };
  };
  
  return {
    isFocused,
    hasInteracted,
    handleFocus,
    handleBlurWithAnimation
  };
}
